<template>
    <div class="quick_container">
      <div>
          <div>
            <img 
              src="https://shoplineimg.com/610d0b05414291002e0cee1f/611b14865972e3003ec266bf/x140.webp?source_format=png"
            />
          </div>
          <h3>Buty99 快速掃瞄核銷</h3>
          <div class="btn-container">
            <!-- <button
              v-on:click="scanQRCode"
            >
              <i class="bi bi-qr-code-scan"></i>
              掃描QR Code
            </button> -->
            <button
              v-if="is_done === true"
              v-on:click="goServiceExecutionList"
            >
              <i class="bi bi-card-checklist"></i>
              
              前往核銷紀錄
            </button>
          </div>
      </div>
    </div>
</template>

<script>
import {
  apiBindLineLogin
} from '@/api/Merchant.js'

import {
  apiCheckTicketNo,
  apiConfirmAttendance
} from '@/api/WorkSite.js'
import liff from "@line/liff";
export default {
  name: 'FastScan',
  components: {
  },
  data: function() {
    return {
      error_message: '',
      line_user_id: '',
      line_access_token: '',
      is_done: false
    }
  }
  ,
  created: function() {
    let that = this
    liff.init({
        'liffId': process.env.VUE_APP_LIFF_QUICK_SCAN
    }).then(function(){
      that.initApp()
    }).catch(function(error){
      that.$swal().close()
      that.error_message = error.toString()
      console.log(error)
    })
  },
  mounted: function(){

  },
  methods:{
    initApp: async function() {
      let that = this
      let aParams = document.location.search.substr(1);

      if (!liff.isLoggedIn() && !liff.isInClient()) {
        let redirect_url = 'https://' + window.location.hostname + window.location.pathname + '?' + ((aParams == null || aParams == '') ? '' : '&' + aParams);
        liff.login({ redirectUri: redirect_url });
      }
      else {
        this.line_access_token = liff.getAccessToken();
        this.line_user_id = await liff.getProfile().then(function(profile) {
          return profile.userId
        }).catch(function(error) {
          console.log(error)
          that.error_message = error.toString()
        });

        console.log(this.line_access_token)
        console.log(this.line_user_id)

        // 先檢查line有沒有綁過後台帳號，沒綁過直接送去綁，什麼都不用做
        let Param = {
          module: 'merchant',
          method: 'bindLineLogin',
          line_id: this.line_user_id,
          access_token: this.line_access_token
        }

        apiBindLineLogin(Param).then(function(resp){
          let data = resp.data
          if (data.ok === 0 || data.goLoginLineBind) {
            console.log('not_bind')
            location.href = 'https://' + window.location.hostname + '/?accessToken=' + that.line_access_token + '&userId=' + that.line_user_id + ((aParams == null || aParams == '') ? '' : '&' + aParams);
            return
          }
          console.log('pass')
          console.log(data)
          // 設定登入後的使用者資料
          that.setLoginData(data.data, '')

          // 有參數的話，直接打整個核銷的API
          const urlParams = new URLSearchParams(window.location.search);
          console.log(urlParams.get('scan_no'))
          if (urlParams.get('scan_no') !== null){
            that.$swal(
                {
                    title: "QR Code讀取中",
                    icon: 'info',
                }                     
            )
            that.checkTicket(urlParams.get('scan_no'))
            window.history.pushState('object', document.title, location.href.split("?")[0]);
          }
          else {
            that.is_done = true
          }
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0 || data.goLoginLineBind) {
            console.log('not_bind')
            location.href = 'https://' + window.location.hostname + '/?accessToken=' + that.line_access_token + '&userId=' + that.line_user_id + ((aParams == null || aParams == '') ? '' : '&' + aParams);
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0 || data.goLoginLineBind) {
        //     console.log('not_bind')
        //     location.href = 'https://' + window.location.hostname + '/?accessToken=' + that.line_access_token + '&userId=' + that.line_user_id + ((aParams == null || aParams == '') ? '' : '&' + aParams);
        //     return
        //   }
          
        //   console.log('pass')
        //   // 設定登入後的使用者資料
        //   vm.setLoginData(data.data, '')

        //   // 有參數的話，直接打整個核銷的API
        //   const urlParams = new URLSearchParams(window.location.search);
        //   console.log(urlParams.get('scan_no'))
        //   if (urlParams.get('scan_no') !== null){
        //     that.$swal(
        //         {
        //             title: "QR Code讀取中",
        //             icon: 'info',
        //         }                     
        //     )
        //     vm.checkTicket(urlParams.get('scan_no'))
        //     window.history.pushState('object', document.title, location.href.split("?")[0]);
        //   }
        //   else {
        //     that.is_done = true
        //   }
        // }, this)

      }
    },
    setLoginData: function(data, landing = '') {
      this.$bus.session = data
      const session_key = this.$bus.getRole() + '_session'
      window.localStorage.setItem(session_key, JSON.stringify(data))
    },
    checkTicket: function(ticket_queue_id){
        let that = this
        // 酷券就當作掃描到那輸入的16碼數字即可
        let Param = {
          module:'work_site',
          method:'checkTicketNo',
          ticket_checkno: ticket_queue_id,
          ticket_no:'',
          ticket_manual_checkno:''
        }
        
        apiCheckTicketNo(Param).then(function(resp){
          let data = resp.data
          console.log('檢查過')
          // 過的狀況，直接再call下一隻api
          let ticket_data = data.data.ticket_data
          that.confirmTicket(
            ticket_data.ticket_check_no, 
            ticket_data.ticket_no,
            ticket_data.do_items[0].ticket_do_item_id,
            ticket_data.do_items[0].ticket_project_service_item_id,
            ticket_data.ticket_possible_project_service_items[0].merchant_service_id
          )
        }).catch(function(error){
          let data = error.response.data
          // 不過的狀況
          if (data.ok === 0) {
            console.log('檢查不過')
            let html_text = ''
            html_text = '<div>'
            html_text +=    '<h5>' + data.msg + '</h5>'
            html_text +=    '<h5 style="color:red; margin-top:1em; margin-botton:0px;">請客人點選重新整理按鈕如下圖:</h5>'
            html_text +=    '<p><img style="width:70%;" src="https://img.shoplineapp.com/media/image_clips/63467d4ba57daf0017f1b763/original.png?1665563979" /></p>'
            html_text += '</div>'
            that.$swal({
              title: "QR Code失效",
              html: html_text,
              // text: data.msg,
              icon: 'warning',
              confirmButtonText: '關閉',
            })
            that.is_done = true
            return
          }
        })
      
        // this.$bus.apiCall(Param, function(data, vm) {
        //   // 不過的狀況
        //   if (data.ok === 0) {
        //     console.log('檢查不過')
        //     let html_text = ''
        //     html_text = '<div>'
        //     html_text +=    '<h5>' + data.msg + '</h5>'
        //     html_text +=    '<h5 style="color:red; margin-top:1em; margin-botton:0px;">請客人點選重新整理按鈕如下圖:</h5>'
        //     html_text +=    '<p><img style="width:70%;" src="https://img.shoplineapp.com/media/image_clips/63467d4ba57daf0017f1b763/original.png?1665563979" /></p>'
        //     html_text += '</div>'
        //     that.$swal({
        //       title: "QR Code失效",
        //       html: html_text,
        //       // text: data.msg,
        //       icon: 'warning',
        //       confirmButtonText: '關閉',
        //     })
        //     that.is_done = true
        //     return
        //   }
        //   console.log('檢查過')
        //   // 過的狀況，直接再call下一隻api
        //   let ticket_data = data.data.ticket_data
        //   that.confirmTicket(
        //     ticket_data.ticket_check_no, 
        //     ticket_data.ticket_no,
        //     ticket_data.do_items[0].ticket_do_item_id,
        //     ticket_data.do_items[0].ticket_project_service_item_id,
        //     ticket_data.ticket_possible_project_service_items[0].merchant_service_id
        //   )
        // }, this)
    },
    confirmTicket: function(ticket_check_no, ticket_no, ticket_do_item_id, ticket_project_service_item_id, merchant_service_id) {
      let that = this
      let Param = {
        module: 'work_site',
        method: 'confirmAttendance',
        ticket_checkno: ticket_check_no,
        ticket_no: ticket_no,
        ticket_do_item_id: ticket_do_item_id,
        ticket_project_service_item_id: ticket_project_service_item_id,
        reservation_id: 0,
        manual_confirm: 1
      }

      apiConfirmAttendance(Param).then(function(resp){
        let data = resp.data

        // 過的狀況
        console.log('核銷成功了')
          let html_text = ''
          html_text = '<div>'
          html_text +=    '<a href="' 
          html_text +=      'https://' + window.location.hostname + '/service_execution_list' + '?merchant_service_id=' + merchant_service_id
          html_text +=    '">點我查看核銷紀錄</a>'
          html_text += '</div>'
          that.$swal({
            title: "核銷成功",
            html: html_text,
            icon: 'success',
            confirmButtonText: '關閉',
          })
          that.is_done = true

      }).catch(function(error){
        let data = error.response.data

        // 不過的狀況
        if (data.ok === 0) {
          console.log('最後核銷失敗')
          let html_text = ''
          html_text = '<div>'
          html_text +=    '<h5>' + data.msg + '</h5>'
          html_text +=    '<h5 style="color:red; margin-top:1em; margin-botton:0px;">請客人點選重新整理按鈕如下圖:</h5>'
          html_text +=    '<p><img style="width:70%;" src="https://img.shoplineapp.com/media/image_clips/63467d4ba57daf0017f1b763/original.png?1665563979" /></p>'
          html_text += '</div>'
          that.$swal({
            title: "QR Code失效",
            html: html_text,
            // text: data.msg,
            icon: 'warning',
            confirmButtonText: '關閉',
          })
          that.is_done = true
          return
        }
      })

      // this.$bus.apiCall(Param, function(data, vm) {

      //   // 不過的狀況
      //   if (data.ok === 0) {
      //     console.log('最後核銷失敗')
      //     let html_text = ''
      //     html_text = '<div>'
      //     html_text +=    '<h5>' + data.msg + '</h5>'
      //     html_text +=    '<h5 style="color:red; margin-top:1em; margin-botton:0px;">請客人點選重新整理按鈕如下圖:</h5>'
      //     html_text +=    '<p><img style="width:70%;" src="https://img.shoplineapp.com/media/image_clips/63467d4ba57daf0017f1b763/original.png?1665563979" /></p>'
      //     html_text += '</div>'
      //     that.$swal({
      //       title: "QR Code失效",
      //       html: html_text,
      //       // text: data.msg,
      //       icon: 'warning',
      //       confirmButtonText: '關閉',
      //     })
      //     that.is_done = true
      //     return
      //   }

      //   // 過的狀況
      //   console.log('核銷成功了')
      //     let html_text = ''
      //     html_text = '<div>'
      //     html_text +=    '<a href="' 
      //     html_text +=      'https://' + window.location.hostname + '/service_execution_list' + '?merchant_service_id=' + merchant_service_id
      //     html_text +=    '">點我查看核銷紀錄</a>'
      //     html_text += '</div>'
      //     that.$swal({
      //       title: "核銷成功",
      //       html: html_text,
      //       icon: 'success',
      //       confirmButtonText: '關閉',
      //     })
      //     that.is_done = true
      // }, this)
    },
    scanQRCode: function() {
      let that = this
      liff.scanCodeV2().then(async (result) => {
          await that.scanCodeHandler(result)
      })
      .catch((error) => {
          that.$swal(
              {
                  title: "掃描失敗",
                  text: '無法取得相機',
                  icon: 'warning',
                  confirmButtonText: '關閉',
              }                     
          )
      });
    },
    scanCodeHandler: async function(result){
      let that = this
      if (result.value == null || result.value == ''){
          that.$swal(
              {
                  title: "掃描失敗",
                  text: '無法讀取QR Code',
                  icon: 'warning',
                  confirmButtonText: '關閉',
              }                     
          )
          return
      }

      result.value = result.value.replace('https://line.me/R/app/' + process.env.VUE_APP_LIFF_QUICK_SCAN + '?scan_no=' , '')

      this.checkTicket(result.value)
    },
    goServiceExecutionList: function() {
      window.location.pathname = 'service_execution_list'
    },
  }
}
</script>

<style scoped>
.quick_container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body_wrapper {
    padding: 5em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.btn-container {
    display: flex;
    flex-direction: column;
    margin-top: 2em;
}
.btn-container > button > i {
  margin-right: 5px;
}
.btn-container > button {
  border:0px;
  background-color: #FF6699 !important;
  color: #FFF;
  font-size: 24px;
  border-radius: 10px;
  margin-bottom: 1.5em;
  padding: 8px 0px;
}
</style>
